import React from 'react';

const AgendaExportEvent = ({oaUrl, oaLabel}) => {
	// Validation des props et gestion des erreurs
	if (!oaUrl || typeof oaUrl !== 'string') {
		return (
			<div role="region" aria-label="Export de l'agenda" className="agenda-export-event-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : URL d'export manquante ou invalide</p>
				</div>
			</div>
		)
	}

	if (!oaLabel || typeof oaLabel !== 'string') {
		return (
			<div role="region" aria-label="Export de l'agenda" className="agenda-export-event-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : libellé d'export manquant ou invalide</p>
				</div>
			</div>
		)
	}

	// Validation de l'URL
	try {
		new URL(oaUrl)
	} catch (error) {
		return (
			<div role="region" aria-label="Export de l'agenda" className="agenda-export-event-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : URL d'export invalide</p>
				</div>
			</div>
		)
	}

	// Construction de l'aria-label pour le lien
	const linkLabel = `${oaLabel} (s'ouvre dans une nouvelle fenêtre)`

	return (
		<div role="region" aria-label="Export de l'agenda" className="agenda-export-event">
			<p className="agenda-export-event-text">
				<a 
					rel="noopener noreferrer" 
					className="btn btn-primary btn-lg btn-pink-3" 
					href={oaUrl} 
					target="_blank"
					role="button"
					aria-label={linkLabel}
					aria-describedby="export-description"
				>
					{oaLabel}
				</a>
			</p>
			
			{/* Description accessible pour les lecteurs d'écran */}
			<div 
				id="export-description" 
				className="visually-hidden" 
				aria-live="polite"
			>
				Ce lien ouvre l'export de l'agenda dans une nouvelle fenêtre ou onglet
			</div>
		</div>
	)
}

export default AgendaExportEvent;
